import _ from 'lodash';
import SweetToast from "../../SweetToast";
const SET_PROCESSING = 'SET_PROCESSING';
const SET_CURRENT_STEP = 'SET_CURRENT_STEP';
const SET_CONNECTED_ACCOUNTS = 'SET_CONNECTED_ACCOUNTS';

function handleAxiosResponseError({ response }) {
  const { error } = response.data;
  SweetToast.fire({
    icon: 'error',
    title: error,
  });
}

export const STEPS = [
  'CONNECT_ACCOUNTS',
  'KEYWORD_IDEAS',
  'SITEMAP',
  'OPTIMISER',
  'COMPLETED',
];

const state = {
  currentStep: null,
  connectedAccounts: {
    analytics: null,
    searchConsole: null,
    businessProfile: null,
  },
  processing: false,
};

const getters = {
  processing({ processing }) {
    return processing;
  },
  connectedAccounts({ connectedAccounts }){
    return connectedAccounts;
  },
  analytics({ connectedAccounts }){
    return connectedAccounts.analytics;
  },
  searchConsole({ connectedAccounts }){
    return connectedAccounts.searchConsole;
  },
  businessProfile({ connectedAccounts }){
    return connectedAccounts.businessProfile;
  },
  currentStep({ currentStep }) {
    return currentStep;
  },
  previousStep({ currentStep }, getters, rootState, rootGetters){
    const filteredSteps = rootGetters['user/hasOptimizerAccessPermission'] ? STEPS : STEPS.filter(step => step !== 'OPTIMISER');
    const currentStepIndex = _.indexOf(filteredSteps, currentStep);
    const previousStepIndex = currentStepIndex - 1;
    return previousStepIndex >= 0 ? filteredSteps[previousStepIndex] : null;
  },
  nextStep({ currentStep }, getters, rootState, rootGetters){
    const filteredSteps = (rootGetters['user/hasOptimizerAccessPermission'] && !rootGetters['user/activeWebsiteIsFreeAppsumo']) ? STEPS : STEPS.filter(step => step !== 'OPTIMISER');
    const currentStepIndex = _.indexOf(filteredSteps, currentStep);
    const nextStepIndex = currentStepIndex + 1;
    return (currentStepIndex >= 0 && nextStepIndex < filteredSteps.length)  ? filteredSteps[nextStepIndex] : null;
  },
};

const actions = {
  fetchOnboardingData({ commit, dispatch }) {
    return new Promise(async (resolve, reject) => {
      commit(SET_PROCESSING, true);
      await Promise.all([
          dispatch('fetchConnectedAccounts'),
          dispatch('fetchCurrentStep'),
        ])
        .then(() => {
          resolve();
        })
        .catch(handleAxiosResponseError)
        .finally(() => {
          commit(SET_PROCESSING, false);
        });
    });
  },
  fetchCurrentStep({commit}) {
    return axios.get('/onboarding/fetch-current-step')
      .then(({ data }) => {
        commit(SET_CURRENT_STEP, data.currentStep);
      }).catch(({ response }) => {
        const { error } = response.data;
        SweetToast.fire({
          icon: 'error',
          title: error,
        });
      });
  },
  fetchConnectedAccounts({commit}) {
    return axios.get('/onboarding/fetch-connected-accounts')
      .then(({ data }) => {
        commit(SET_CONNECTED_ACCOUNTS, data.connectedAccounts);
      }).catch(handleAxiosResponseError);
  },
  updateCurrentStep({ commit }, step) {
    commit(SET_PROCESSING, true);
    axios.post(`/onboarding/update-current-step`, {
        step: step,
      })
      .then(() => {
        commit(SET_CURRENT_STEP, step);
        commit(SET_PROCESSING, false);
      })
      .catch(handleAxiosResponseError)
      .finally(() => {
        commit(SET_PROCESSING, false);
      });
  },
  completeOnboarding({commit}) {
    commit(SET_PROCESSING, true);
    return axios.get('/onboarding/complete')
      .then(({ data }) => {
        window.location.href = data.redirectUrl;
        commit(SET_PROCESSING, false);
      })
      .catch(handleAxiosResponseError)
      .finally(() => {
        commit(SET_PROCESSING, false);
      });
  }
};

const mutations = {
  [SET_CURRENT_STEP](state, currentStep) {
    state.currentStep = currentStep;
  },
  [SET_PROCESSING](state, processingState){
    state.processing = processingState;
  },
  [SET_CONNECTED_ACCOUNTS](state, connectedAccounts){
    state.connectedAccounts = {...connectedAccounts};
  }
};

const onboarding = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
export default onboarding;
